<template >
  <div>
    <div class="list-group">
      <v-card tile height="100vh" max-height="calc(100% - 120px)" width="240" class="rounded-0 elevation-0">
        <div class="list-group-title">
          Деятельность совета
        </div>

        <v-navigation-drawer permanent>
          <v-list-item-group color="var(--app-dark-blue-1)" v-model="selectedTicker" style="top:8px;">
            <v-list-item dense :key="index" style="height:48px;" v-for="(item, index) in items">
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-navigation-drawer>
      </v-card>
    </div>
    <div class="component" v-if="typeof selectedTicker == 'number'">
      <component v-bind:is="items[selectedTicker].content"></component>
    </div>
  </div>
</template>

<script>
import WorkPlan from "@/views/CouncilActivity/WorkPlan";
import Meetings from "@/views/CouncilActivity/Meetings";
import Other from "@/views/CouncilActivity/Other";
import Vote from "@/views/CouncilActivity/Vote";
import Contacts from "@/views/CouncilActivity/Contacts";


export default {
  name: 'users',
  components: {
    WorkPlan,
    Meetings,
    Other,
    Vote,
    Contacts

  },

  data: () => ({

    selectedTicker: 0,
    items: [
      {
        title: 'Документы',
        content: 'WorkPlan',
      },
      {
        title: 'Заседания и отчеты',
        content: 'Meetings',
      },
      {
        title: 'Деятельность',
        content: 'Other',
      },
      {
        title: 'Голосование',
        content: 'Vote',
      },
      {
        title: 'Контакты',
        content: 'Contacts',
      },





    ],

  }),

  created() {
    if (this.$route.params.selectedTicker) {
      this.selectedTicker = this.$route.params.selectedTicker
    }
  },

  methods: {

  },
  watch: {

  },
}
</script>
<style scoped>
.v-list-item__title {
  font-size: 1rem;
}


.list-group {
  position: fixed;
  display: block;
  margin: 0;
  padding: 0;
  width: 240px;
  max-width: 240px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;

  color: #F8F8F8;
}

.component {
  position: absolute;
  left: 240px;
  width: calc(100% - 240px);

}

.list-group-title {
  font-size: 28px;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 34px;
  padding-left: 14px;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
}
</style>
